import { AbstractControl, ValidatorFn } from '@angular/forms';
import { ValueType } from '../types/pricing.types';

export function crossFieldPercentValidator(
  valueTypeControlName: string,
  discountValueControlName: string
): ValidatorFn {
  return (group: AbstractControl) => {
    const valueTypeControl = group.get(valueTypeControlName);
    const discountValueControl = group.get(discountValueControlName);

    if (!valueTypeControl) {
      console.warn('Field doesnt exist ', valueTypeControlName);
      return null;
    }
    if (!discountValueControl) {
      console.warn('Field doesnt exist ', discountValueControlName);
      return null;
    }

    const valueType = valueTypeControl.value;
    const discountValue = discountValueControl.value;

    // Only validate if valueType is Percentage
    if (valueType === ValueType.Percentage) {
      // Check if discountValue exceeds 99
      if (
        discountValue !== null &&
        discountValue !== undefined &&
        discountValue > 100
      ) {
        const existingErrors = discountValueControl.errors || {};
        discountValueControl.setErrors({ ...existingErrors, maxPercent: true });
      } else {
        // Clear the maxPercent error if it exists
        clearSpecificError(discountValueControl, 'maxPercent');
      }
    } else {
      // If not percentage, clear the maxPercent error if it exists
      clearSpecificError(discountValueControl, 'maxPercent');
    }

    // Clear errors completely if no errors remain
    resetErrorsIfEmpty(discountValueControl);

    return null;
  };

  // Helper functions
  function clearSpecificError(
    control: AbstractControl,
    errorKey: string
  ): void {
    const errors = control.errors;
    if (errors && errors[errorKey]) {
      delete errors[errorKey];
      control.setErrors(Object.keys(errors).length > 0 ? errors : null);
    }
  }

  function resetErrorsIfEmpty(control: AbstractControl): void {
    if (!Object.keys(control.errors ?? {}).length) {
      control.setErrors(null);
    }
  }
}
